


















import { Vue } from "vue-property-decorator";
export default Vue.extend({
  props: {
    color: {
      type: String,
      default: "FF0000"
    }
  }
});
